export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', {
    beforeMount(el, binding) {
      setTimeout(() => {
        el.__clickOutsideHandler__ = (event: MouseEvent) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.addEventListener('click', el.__clickOutsideHandler__)
      }, 0)
    },
    unmounted(el) {
      document.removeEventListener('click', el.__clickOutsideHandler__)
    },
  })
})
